import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";

function useFetch<T>(endpoint: string, params?: { [key: string]: any; }, p0?: string[]) {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const apiKey = process.env.REACT_APP_API_KEY;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const paramsString = JSON.stringify(params);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedParams = useMemo(() => params, [paramsString]);

  const fetchData = useCallback(() => {
    if (
      !memoizedParams ||
      (memoizedParams.companyName && memoizedParams.companyName.trim() !== "") // Check if there are any params
    ) {
      axios
        .get(baseUrl + endpoint, {
          params: memoizedParams,
          headers: {
            Authorization: apiKey,
          },
        })
        .then((response) => {
          setData(response.data.results);
        })
        .catch((error) => {
          console.error("There was an error!", error.response);
        })
        .finally(() => setLoading(false));
    } else {
      console.log(
        "Fetch not called due to issue probably params",
        memoizedParams
      );
      setLoading(false);
      setData([]);
    }
  }, [apiKey, baseUrl, endpoint, memoizedParams]);

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(fetchData, 600000);

    return () => clearInterval(intervalId);
  }, [fetchData]);

  return { data, loading };
}

export default useFetch;
